import type { QueryProps } from "shared/react";
import type { MemberData } from "shared/schema";
import { CardLoader, List, MenuButton } from "shared/react";
import { ProfileCard } from "../profile/ProfileCard.js";
import { useQuery } from "../util/db.js";
import { MemberMenu } from "./MemberMenu.js";
import { MemberStatusBadge } from "./MemberStatusBadge.js";

export function MemberList({ gid, query, ...props }: { gid: string } & QueryProps<MemberData>): React.ReactElement {
	return (
		<List
			store={useQuery("member", query)}
			mapper={({ uid, status }) => (
				<CardLoader key={uid}>
					<ProfileCard uid={uid}>
						<MenuButton menu={<MemberMenu gid={gid} uid={uid} />} mods="button-quiet pin-top pin-right" />
						<MemberStatusBadge status={status} mods="pin-bottom pin-right" />
					</ProfileCard>
				</CardLoader>
			)}
			{...props}
		/>
	);
}
